import Commerce from '@chec/commerce.js';

export const commerce = new Commerce('pk_test_205284d238324c0af023ba6ba1f1f6cd5ea1c14353fda', true);   